import TitleContainer from "../TitleContainer/TitleContainer";
import Block from '../Block/Block'
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";

function List({type, data, title, url}) {

    return (
        <>
            <TitleContainer title={title} {...(url ? {url: urlWithRoutingCompany(url)} : null)} />
            <div className="list">
                { data && data.map( (block, index) => <Block key={index} type={type} {...block}/>)}
            </div>
        </>
    )
}

List.defaultProps = {
    data : []
}

export default List;